
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/link/data-transparency-messaging-migration-guide",
      function () {
        return require("private-next-pages/docs/link/data-transparency-messaging-migration-guide.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/link/data-transparency-messaging-migration-guide"])
      });
    }
  